import { useToast } from "@homebound/beam";
import { useEffect, useMemo } from "react";
import { LotType, Project, ScheduleStatus, Stage } from "src/generated/graphqlTypes";
import { useScheduleParentGlobalMilestoneTasksQuery } from "src/routes/projects/schedule-v2/ProjectSchedulePageV2.generated";
export type ScheduleOutOfSyncToastProps = { scheduleParentId: string; scheduleStatus: ScheduleStatus; stage: Stage };

// This component is only rendered on Construction schedules
export function ScheduleOutOfSyncToast(props: ScheduleOutOfSyncToastProps) {
  const { scheduleParentId, scheduleStatus, stage } = props;
  const { showToast } = useToast();
  const { data } = useScheduleParentGlobalMilestoneTasksQuery({
    variables: { scheduleParent: scheduleParentId },
    // only run this query on construction schedules
    skip: stage !== Stage.Construction,
  });

  // Key on the query result's value, not the reference Apollo re-creates on unrelated cache
  // writes, so the toast only re-evaluates when the milestone data actually changes.
  const dataKey = useMemo(() => JSON.stringify(data), [data]);

  useEffect(() => {
    if (!data) return;
    const beginningMilestone = data.scheduleTasks.find((task) => task.globalTask?.beginsStage === Stage.Construction);
    const startDeterminingMilestone = data.scheduleTasks.find(
      (task) => task.globalTask?.determinesStartDateForStage === Stage.Construction,
    );
    const preConSchedule = data.schedules.find((schedule) => schedule.stage === Stage.PreConExecution);
    if (!beginningMilestone || !startDeterminingMilestone || !preConSchedule) return;

    /**
     * Show a toast for out of sync milestones on
     * - Draft Construction schedules
     * - Active Construction schedules for Boyl lot types
     */
    if (
      (scheduleStatus === ScheduleStatus.Draft ||
        (scheduleStatus === ScheduleStatus.Active &&
          (preConSchedule.parent as Project).lotType?.code === LotType.Boyl)) &&
      !beginningMilestone.interval.startDate.equals(startDeterminingMilestone.interval.endDate)
    ) {
      showToast({
        type: "info",
        message:
          "Pre-Con and Construction Ready To Start milestones are un-synced. Move the pre-con RTS to the same or later date as the construction RTS to re-sync.",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataKey, scheduleStatus, showToast]);

  return <></>;
}
